/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 付帯商品契約情報
 */
export interface Sgkb981aFtiGoodsDto {
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 商品契約利用開始日付：日付(yyyyMMdd)
     */
    useStartDate?: string;
    /**
     * 商品契約満了予定日付：日付(yyyyMMdd)
     */
    ctrExpireDate?: string;
    /**
     * プロダクト商品画面用名称：全角
     */
    prdGoodsDisp?: string;
    /**
     * 継続年数：数字
     */
    duration?: number;
    /**
     * 継続年数表示フラグ：boolean
     */
    dispContinuYears?: boolean;
}

